import { Card } from '@/elements';

export const ArticleCard: typeof Card = ({ children, ...rest }) => (
  <Card {...rest} display='flex' flexDirection='column'>
    {children}
  </Card>
);
